export const visit = (vm, at) => {
at({ "da": { "conversations-message-history": { "responder": { "automatic": "Automatiseret", "bot": "Bot", "unknownResponder": "Ukendt bruger", "unknownSender": "Ukendt afsender", "unknownVisitor": "Ukendt bes\xF8gende", "unknownVisitorAvatar": "Ukendt bes\xF8gende" } } } });
};